import { createSelector } from 'reselect';
import { getPartnerCartErrors } from '@nike/partnercart-redux';
import { getCartErrors } from '@nike/ux-tread-cart-redux';

const getAllCartErrors = createSelector(
  getCartErrors,
  getPartnerCartErrors,
  (cartErrors, partnerCartErrors) => [...cartErrors, ...partnerCartErrors],
);

export default getAllCartErrors;
